@use 'src/globals/main';

$resize-icon-default: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M7%2017L17%207M12%2017L17%2012%22%20stroke%3D%22%23005D92%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E';

pn-textarea {
  display: inline-flex;
  flex-direction: column;
}

pn-textarea .pn-textarea {
  // Label container
  &-label {
    @include main.pn-input-label;
  }

  &-text {
    @include main.pn-input-helpertext;
    > pn-icon {
      margin-right: 0.25em;
    }
  }

  &-element {
    @include main.pn-input-field;
    @include main.pn-scrollbar;

    width: 100%;
    resize: none;

    &:read-only {
      @include main.pn-readonly;
    }

    &::-webkit-resizer {
      background-image: url($resize-icon-default);
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  &[data-valid] {
    > .pn-textarea-label {
      color: main.$label-color-success;
    }
    > .pn-textarea-element {
      @include main.pn-input-field-success;
    }
  }

  &[data-error] {
    > .pn-textarea-label {
      color: main.$label-color-error;
    }
    > .pn-textarea-element {
      @include main.pn-input-field-error;
    }
    > .pn-textarea-text[role='alert'] {
      color: main.$helpertext-color-error;
    }
  }

  &[data-resize] > .pn-textarea-element {
    resize: vertical;
  }
}
